import { render, staticRenderFns } from "./CustomPublishers.vue?vue&type=template&id=b3c60bb6&scoped=true"
import script from "./CustomPublishers.vue?vue&type=script&lang=js"
export * from "./CustomPublishers.vue?vue&type=script&lang=js"
import style0 from "./CustomPublishers.vue?vue&type=style&index=0&id=b3c60bb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c60bb6",
  null
  
)

export default component.exports